import { render } from "./stat2.vue?vue&type=template&id=80a16fba"
import script from "./stat2.vue?vue&type=script&lang=js"
export * from "./stat2.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/oralhealthmap.uz/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__